<template>
          <div>

              <div v-if="Object.keys(zakazy_payed).length > 0">
                <b-form-select
                  v-model="zakazy_payed_index"
                  class="d-block d-lg-none"
                >
                  <template v-for="(dt,index) of  Object.keys(zakazy_payed)">
                    <b-form-select-option 
                      :key="index" 
                      :value="index"
                    >  
                      {{new Date(dt) | dateFormat('dddd D MMMM')}}
                    </b-form-select-option>
                  </template>
                </b-form-select>

                <b-card no-body>
                  <b-tabs 
                    small 
                    pills 
                    card 
                    vertical 
                    v-model="zakazy_payed_index"
                    nav-wrapper-class="d-none d-lg-block"
                    active-nav-item-class = "bg-bruvis text-white"
                  >
                    <b-tab v-for="(dt,index) of  Object.keys(zakazy_payed)" :title="new Date(dt) | dateFormat('dddd D MMMM')" :key="index" class="text-center">
                      <template v-if="zakazy_payed[dt] != null">
                        <div class="perforated_check mx-auto" v-for="(ch,index2) of zakazy_payed[dt]" :key="index2">

                          <svg width="200px" viewBox="0 0 300 5" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0,0 300,0" fill="none" stroke="#e2e3de" stroke-dasharray="3 3" stroke-width="20"/>
                          </svg>
                          <!--b-icon
                            v-if="!ch.canceled && (ch.paytype===2 || ch.paytype===3)" 
                            icon="x-circle-fill" 
                            class="ico-del-zakaz "
                            variant="danger"
                            font-scale="1.3"
                            v-b-popover.hover.topright="'Анулювати замовлення'"
                            role="button"
                            @click="annulOrder(ch.rn)"
                          ></b-icon-->

                          <b-iconstack  
                            v-if="!ch.canceled && ((ch.paytype===2 && settings.enable_annul_liqpay_payed) || ch.paytype===3)" 
                            role="button" 
                            class="ico-del-zakaz"
                            font-scale="1.5"
                            v-b-popover.hover.topright="'Анулювати замовлення'"
                            @click="annulOrder(ch.rn)"
                          >
                            <b-icon stacked icon="square-fill" variant="white"></b-icon>
                            <b-icon stacked icon="square" variant="dark"></b-icon>
                            <b-icon stacked icon="trash-fill" variant="danger" scale="0.6"></b-icon>
                          </b-iconstack>

                          <b-iconstack  
                            v-if="!ch.canceled && salepoint && salepoint.beforeMealTimes && ch.paytype===3" 
                            role="button" 
                            class="ico-edit-zakaz"
                            font-scale="1.5"
                            v-b-popover.hover.topright="'Редагування замовлення'"
                            @click="editbusy=true,editPayedOrder(ch.rn)"
                          >
                            <b-icon stacked icon="square-fill" variant="white"></b-icon>
                            <b-icon stacked icon="square" variant="dark"></b-icon>
                            <b-icon stacked icon="pencil" variant="dark" scale="0.6" :animation="(editbusy)?'spin':'none'"></b-icon>
                          </b-iconstack>


                            <table class="teble mx-auto w-100">
                              <tr :key="index2">
                                <th colspan=2 class="text-center pb-3 pt-3">
                                  Рахунок № {{ch.checknum}}<br>
                                  <template v-if="ch.mealtime && mealtimes[ch.mealtime]">{{(mealtimes[ch.mealtime]).mnemo}}</template> {{new Date(dt) | dateFormat('DD.MM.YYYY')}}
                                  <template v-if="ch.canceled"><div class="shtamp-canceled">Анульовано!</div></template>
                                </th>
                              </tr>
                              <template v-if="ch.checknum==='___'">
                                <tr :key="index2">
                                  <td colspan=2><b-spinner small label="Loading..." class="m-5"></b-spinner></td>
                                </tr>
                              </template>
                              <template v-else>
                                <tr v-for="(sp,index3) in ch.specs" :key="index3">
                                  <td class="text-left pr-3 pl-1">{{sp.menu}}<!--template v-if="sp.quant>0 && sp.quant!==1"> (x{{sp.quant}})</template--></td>
                                  <td class="text-right text-nowrap pl-3 pr-1"><template v-if="sp.quant>0 && sp.quant!==1">{{sp.quant}} x </template>{{sp.price | toCurrency}}</td>
                                </tr>
                              </template>  
                              <tr class="bordered-top" :key="index2" v-if="ch.totalDiscountSum > 0">
                                <td class="text-left pr-3 pl-1">Знижка</td>
                                <td class="text-right pl-3 pr-1 text-nowrap">- {{ch.totalDiscountSum | toCurrency}}</td>
                              </tr>
                              <tr :key="index2">
                                <th class="text-left pr-3 pl-1">Разом сплачено</th>
                                <th class="text-right pl-3 pr-1">{{ch.sumToPay | toCurrency}}</th>
                              </tr>
                              <!--tr :key="index2" v-if="ch.paytype">
                                <th class="text-left pr-3 pl-1">Paytype</th>
                                <th class="text-right pl-3 pr-1">{{ch.paytype}}</th>
                              </tr-->
                              <tr :key="index2" v-if="ch.canceled">
                                <th class="text-left pr-3 pl-1 comment-canceled">Повернено на баланс клубної карти</th>
                                <th class="text-right pl-3 pr-1 comment-canceled">{{ch.sumToPay | toCurrency}}</th>
                              </tr>
                            </table>
                        </div>
                      </template>
                    </b-tab>
                  </b-tabs>
                </b-card>  
                <!--------------------------------------------------------->
                <!--b-modal 
                  id="modal-annul-variant" 
                  centered 
                  size="md" 
                  :no-close-on-backdrop="true"
                >
                  <b-overlay
                    :show="annulvariantbusy"
                    rounded
                    variant="white"
                    blur="2px" 
                    opacity="0.9"
                    spinner-variant="bruvis"
                    class="d-inline-block w-100"
                    style="inset:0px;"
                  >
                  <div>
                    <b-card-group deck>
                      <b-card role="button" @click="console.log(111)">
                        <b-img src="img/liqpay_0.png" fluid/>
                      </b-card>
                      <b-card role="button" @click="console.log(222)">
                        <b-row align-v="end">
                          <b-col>
                            <b-img src="img/ballance2.png" fluid/>
                          </b-col>
                          <b-col align="center">
                            <h5>Клубна карта</h5>
                          </b-col>
                        </b-row>
                      </b-card>
                    </b-card-group>
                  </div>
                  </b-overlay>
                  <template #modal-footer>
                    <b-button variant="bruvis" @click="$bvModal.hide('modal-annul-variant')">
                      Закрити
                    </b-button>
                  </template>
                </b-modal-->
                <!--------------------------------------------------------->
              </div>
              <div v-else class="text-center">
                <h5>Замовлень немає</h5>
              </div>

            <!--template v-else>
              <EditOrder
                :order2edit="order2edit"
                :salepoint="salepoint"
                :dishes="dishes"
                mode = "editpayed"
                @onsuccess = "order2edit=null,$emit('ondelete')"
                @needlogin = "needlogin = true"
                @close = "$bvModal.hide('order-edit-modal')"
                @closepayed = "order2edit=null"
              ></EditOrder>
            </template-->    

          <!-- Edit ORDER Begin ------------------------------------------------------------>
            <b-modal id="order-payed-edit-modal" hide-header-close 
              centered scrollable size="lg" :no-close-on-backdrop="true"
              ok-variant="bruvis"
              ok-title="Закрити"
              hide-footer
            >
              <template #modal-title>
                <b-icon icon="pencil" class="rounded bg-success p-1" variant="light" font-scale="1.3"></b-icon> <span class="p-2 h5 mr-auto">Редагування замовлення</span>
              </template>
              <EditPayedOrder
                :order2edit="order2edit"
                :sumlimit="sumlimit"
                :cardlimit="cardlimit"
                :dishes="dishes"
                :menu = "simplemenu"
                :salepoint="salepoint" 
                @onsuccess = "tempClearDishes(),order2edit=null,sumlimit=null,cardlimit=null,$emit('ondelete')"
                @needlogin = "$emit('needlogin')"
                @close = "order2edit=null,sumlimit=null,cardlimit=null,$bvModal.hide('order-payed-edit-modal')"
              ></EditPayedOrder>

            </b-modal>
          <!-- Edit ORDER END ------------------------------------------------------------> 


          </div>  

</template>

<script>

import EditPayedOrder from './orderpayededit.vue'

export default {
  name: 'ZakazyPayed',
  components: {
    EditPayedOrder
  },
  props: {
    zakazy_payed: {
      type: Object,
      required: true
    },
    mealtimes:{
      type: Object,
      required: true
    },
    salepoint:{
      type: Object,
      required: true
    },
    dishes:{
      type: Object,
      required: true
    },
    settings:{
      type: Object,
      required: true
    }
  },
  data: () => ({
      zakazy_payed_index: 0,
      annulvariantbusy: false,
      order2edit: false,
      sumlimit: null,
      cardlimit: null,
      simplemenu: null,
      editbusy: false                         
  }),
  methods:{

    showMsgBoxOrderAnnulConfirm(rn) {
      //**************

      this.$axios.post('', {"action":"preannulorder","rn":rn } )
        .then((response) => {
          if(response.data.success != false && response.data.success != 'false'){
            //  аннулирование возможно
            if(response.data.paytype===3) { // || (response.data.paytype===3 && !response.data.creditcardenable)
              //***************************************************************************************** */
              this.$bvModal.msgBoxConfirm('При анулюванні оплаченого замовлення кошти зараховуються на баланс клубної карти. Ви дійсно бажаєте продовжити?', {
                          title: 'Підтвердження',
                          size: 'sm',
                          buttonSize: 'sm',
                          okVariant: 'danger',
                          okTitle: 'Анулювати',
                          cancelVariant: 'success',
                          cancelTitle: 'Відмінити',
                          footerClass: 'p-2',
                          hideHeaderClose: false,
                          centered: true
                        })
                        .then(value => {
                              if(value === true) {
                                return this.annulOrder(rn,'true')
                              }else if(value === false) {
                                return 
                              }
                        })
                        .catch(err => {
                          console.log('Annul order '+err)
                        })
              //***************************************************************************************** */
            }else if(response.data.paytype===2 && this.settings.enable_annul_liqpay_payed) {
               this.$bvModal.msgBoxConfirm('Це замовлення було сплачено через LiqPay. Бажаєте нарахувати кошти на клубну карту, чи замовити повернення через Liqpay?', {
                          title: 'Повернення коштів',
                          size: 'sm',
                          buttonSize: 'sm',
                          okVariant: 'bruvis',
                          okTitle: 'Клубна карта',
                          cancelVariant: 'success',
                          cancelTitle: 'LiqPAY',
                          footerClass: 'p-2',
                          hideHeaderClose: false,
                          centered: true
                        })
                        .then(value => {
                              if(value === true) {
                                return this.annulOrder(rn,'true')
                              }else if(value === false) {
                                //this.$toasted.success('Типа повернення через LiqPAY').goAway(3000)
                                this.$toasted.error('Повернення через LiqPAY наразі неможливо').goAway(3000)
                                return 
                              }
                        })
                        .catch(err => {
                          console.log('Annul order '+err)
                        })

            }  
          }else{
            if(response.data.error=="auth" || response.data.error=="tokenout"){
              this.$emit('needlogin')
            }else{
              this.$bvModal.msgBoxOk(response.data.message, {
                title: 'Попередження',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'bruvis',
                okTitle: 'Ok',
                footerClass: 'p-2',
                hideHeaderClose: true,
                centered: true,
                headerClass: 'bg-danger text-white border-danger',
              })
              .then(value => {
                console.log(value)
                return
              })
            }
          }  
        })
        .catch(error => {
          this.ordersbusy = false
          console.error('There was an error!', error)
        });



      //**************************
      /*
      this.$bvModal.msgBoxConfirm('Ви дійсно бажаєте анулювати замовлення?', {
        title: 'Підтвердження',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Анулювати',
        cancelVariant: 'success',
        cancelTitle: 'Відміна',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
      .then(value => {
            if(value === true) {
              return this.annulOrder(rn,'true')
            }else if(value === false) {
              return 
            }
      })
      .catch(err => {
        console.log('Annul order '+err)
      })
      */
    },

    annulOrder(rn,confirm) {
      if(!confirm){
        this.showMsgBoxOrderAnnulConfirm(rn)
        return
      }
      if(confirm === 'false'){
        return
      }
      //this.$emit('globalbusy')
      //this.ordersbusy = true
      this.$axios.post('', {"action":"annulorder","rn":rn } )
        .then((response) => {
          if(response.data.success != false && response.data.success != 'false'){
            this.$toasted.success(response.data.message).goAway(3000)
            this.$emit('ondelete')
            //this.ordersbusy = false
          }else{
            //this.ordersbusy = false
            if(response.data.error=="auth" || response.data.error=="tokenout"){
              //this.needlogin = true
              this.$emit('needlogin')
            }else{
              this.$toasted.error(response.data.message).goAway(3000) 
            }
          }  
        })
        .catch(error => {
          this.ordersbusy = false
          console.error('There was an error!', error)
        });
      
    },

    editPayedOrder(rn) {
      //this.$emit('globalbusy')
      //this.ordersbusy = true
      this.$axios.post('', {"action":"preeditpayedorder","rn":rn } )
        .then((response) => {
          this.editbusy=false
          if(response.data.success != false && response.data.success != 'false'){
            //this.$toasted.success(response.data.message).goAway(3000)
            //this.editOrder(response.data.order2edit,response.data.sumlimit,response.data.cardlimit)
            this.editOrder(response.data.ordfood2edit,response.data.sumlimit,response.data.cardlimit)
            this.simplemenu = response.data.menu

            //this.$emit('ondelete')
            //this.ordersbusy = false
          }else{
            //this.ordersbusy = false
            if(response.data.error=="auth" || response.data.error=="tokenout"){
              //this.needlogin = true
              this.$emit('needlogin')
            }else{
              this.$toasted.error(response.data.message).goAway(3000) 
            }
          }  
        })
        .catch(error => {
          this.ordersbusy = false
          this.editbusy=false
          console.error('There was an error!', error)
        });
      
    },

    editOrder(zkz,lim,cardlim){
      this.order2edit = zkz
      this.sumlimit = lim 
      this.cardlimit = cardlim 
      this.$bvModal.show('order-payed-edit-modal')
    },

    tempClearDishes(){
      Object.values(this.zakazy_payed).forEach((o)=>{
        o[0].checknum = "___"
        o[0].sumToPay = 0
/*
        o[0].specs.forEach((s)=>{
          s.checknum = "___"
        })
*/
      })
    }

  }
}
</script>

<style scoped>

.check{
  padding: 5px;
  background:
    linear-gradient(-45deg, #0000 6px, #fff 7px),
    linear-gradient( 45deg, #0000 6px, #fff 7px),
    linear-gradient(-45deg, #fff calc(100% - 7px), #0000 calc(100% - 8px)),
    linear-gradient( 45deg, #fff calc(100% - 7px), #0000 calc(100% - 8px));
  background-size: 10px 50%;
  background-position: 0 100%, 0 100%, 0 0, 0 0;
  background-repeat: repeat-x;
  font-family: courier;
}

.perforated_check{
  position: relative;
  margin: 3px;
  width: 400px;
  min-height: 200px;
  background: #e2e3de;
  padding: 4px 20px;
  box-shadow: 10px 10px 20px rgb(0 0 0 / 20%);
  font-family: courier;
}

.perforated_check svg{
  position: absolute;
  top: -3px;
  left: 2px;
  width: 100%;
}

.perforated_check table td{
  border-bottom: 1px dashed #c5c5c5;
  vertical-align: top;
}

.perforated_check table {
  margin-bottom:20px;
}

svg.ico-del-zakaz,
svg.ico-edit-zakaz{
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s, opacity 0.5s linear;
  position: absolute;
  top: 23px;
  left: 21px;
  width: 30px;
}  

svg.ico-edit-zakaz{
  left: 50px;
}  

.perforated_check:hover svg.ico-del-zakaz,
.perforated_check:hover svg.ico-edit-zakaz{
  visibility: visible;
  opacity: 1;
}

.shtamp-canceled{
  color: #b9333f;
  background-color: transparent;
  border: 3px solid #b9333f;
  border-radius: 0.25rem;
  position: absolute;
  padding: 0.75rem 1.25rem;
  transform: rotate(45deg);
  opacity: 0.7;
}

.comment-canceled{
  color: #b9333f;
  padding-top: 0.5em;
}  


@media (max-width: 575px) {
  .perforated_check{
    width: 100%;
/*    min-height: 200px;*/
  }
  .card-body {
    padding:0;
  }

}

@media (hover: none) {
  svg.ico-del-zakaz,
  svg.ico-edit-zakaz{
    visibility: visible;
    opacity: 1;
  }    

}    

.modal-backdrop {
  background-color: #6c757de6 !important;
  opacity: 1 !important;
}

</style>
